/* eslint-disable no-param-reassign */
/* eslint-disable prefer-destructuring */
import Vue from 'vue';
import i18n from '../i18n';

const vueInstance = new Vue();

function showError(error) {
  vueInstance.$toasted.error(error);
}

const notificationService = {
  success: (message, translate = false) => {
    let successMessage = i18n.t('all.done');
    if (translate) {
      successMessage = i18n.t(`all.${message}`);
    } else {
      successMessage = message;
    }
    vueInstance.$toasted.success(successMessage);
  },

  showLoader: message =>
    vueInstance.$toasted.show(i18n.t(`all.${message}`), {
      position: 'bottom-center',
      singleton: true,
      icon: 'hourglass_empty',
    }),

  stopLoader: () => vueInstance.$toasted.clear(),

  show: message => vueInstance.$toasted.show(message),

  error: (error, translate = false) => {
    try {
      let message = i18n.t('all.unexpectedError');
      if (!translate) {
        if (typeof error === 'string') {
          message = error;
        } else if (error.response.message) {
          message = error.response.message;
        } else if (error.response.data.message) {
          message = error.response.data.message;
        } else if (error.body) {
          if (typeof error.body === 'string') {
            message = error.body;
          } else if (error.body.error) {
            message = error.body.error;
          } else if (error.body.message) {
            message = error.body.message;
          }
        }
      } else {
        message = i18n.t(`all.${error}`);
      }
      showError(message);
    } catch (e) {
      showError(i18n.t('all.unexpectedError'));
    }
  },
};

export default notificationService;
